import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FrameworkService } from '@anecdotes/data-store';
import { TrustCenterFacadeService, FrameworkResponse } from '@anecdotes/shared-trust-center';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';

@Component({
  selector: 'app-framework-summary-edit',
  templateUrl: './framework-summary-edit.component.html',
  styleUrls: ['./framework-summary-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FrameworkSummaryEditComponent implements OnInit, OnDestroy {
  @Input()
  frameworkId: string;

  frameworkData$: Observable<FrameworkResponse>;
  icon$: Observable<string>;

  constructor(
    private frameworkService: FrameworkService,
    @SkipSelf() private loaderManager: LoaderManagerService,
    private readonly trustCenterModalsService: TrustCenterModalService,
    private trustCenterFacadeService: TrustCenterFacadeService,
  ) {}

  ngOnInit(): void {
    this.frameworkData$ = this.trustCenterFacadeService.getFramework(this.frameworkId);
    this.icon$ = this.frameworkData$.pipe(map(({ icon_id }) => this.frameworkService.getFrameworkIconLink(icon_id)));
  }

  ngOnDestroy(): void {
    this.loaderManager.hide();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  onEditClick(): void {
    this.trustCenterModalsService.openFrameworkEditSidePanel(this.frameworkId);
  }
}
